/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-input-element[type=date][_ngcontent-%COMP%]::after{content:\"\"!important}"];
export { styles as styles };
